module.exports = __webpack_public_path__ + "static/media/keto-extreme-5.ddd00f2b.png";